import { AfterViewInit, Component, OnInit } from "@angular/core";
import { Toaster, Type } from "../../../../toaster/Toaster";
import { AttributeCode, AttributeValue, UserAttributeInterface } from "../../../../model/finzy-flex/user-attribute.model";
import { SharedPreferenceDataService } from "../../../../service/shared-preference-data.service";
import { ActivatedRoute, Router, Event, NavigationEnd } from "@angular/router";
import { Keys, StorageService } from "../../../../../../src/app/service/storage.service";
import { MatDialog } from "@angular/material";
import { EnableSwiftPreferencePopUpComponent } from "../enable-swift-preference-pop-up/enable-swift-preference-pop-up.component";
import { FfEndPoints } from "../ff-endpoints";
import { LenderAccountInfo } from "../../../../model/finzy-flex/lender-account.model";
import { UserAttributeService } from "../../../../../../src/app/service/finzy-flex/user/user-attribute.service";
import { AccountService } from "../../../../../../src/app/service/finzy-flex/account/account.service";

@Component({
    selector: 'app-flex-home',
    templateUrl: './flex-home.component.html',
    styleUrls: ['./flex-home.component.css']
})
export class FlexHomeComponent implements OnInit, AfterViewInit {
    private readonly sharedPreferenceDataService: SharedPreferenceDataService;
    private  userAttributes: UserAttributeInterface = null;
    private readonly storageService: StorageService;
    private readonly userAttributeService: UserAttributeService;
    private readonly accountService: AccountService
    private readonly matDialog: MatDialog;
    private router: Router;
    public isSwiftOn: boolean = false;
    public isNCashOn: boolean = false;
    public showQuickSetup: boolean = false;
    public lenderAccountInfo: LenderAccountInfo = null;

    constructor(
        sharedPreferenceDataService: SharedPreferenceDataService,
        activatedRoute: ActivatedRoute,
        storageService: StorageService,
        matDialog: MatDialog,
        router: Router,
        userAttributeService: UserAttributeService,
        accountService: AccountService
    ) {
        this.sharedPreferenceDataService = sharedPreferenceDataService;
        this.storageService = storageService;
        this.matDialog = matDialog;
        this.router = router;
        this.userAttributeService = userAttributeService;
        this.accountService = accountService;
        this.showQuickSetupConfig();
    }
    
    async ngOnInit() {
        await this.getLenderPreferences();
        await this.getLenderAccountInfo();
        await this.checkForPreferenceType();
        this.readPreferenceSharedData();
        this.showEnableSwiftPopUp();
        this.showQuickSetupConfig();
    }

    ngAfterViewInit(): void {
        // document.getElementById('interestCertificate').style.display = "none"
    }

    private async getLenderPreferences() {
        const profileId = this.storageService.getItem(Keys.PROFILE_ID);
        try {
            const userAttribute = await this.userAttributeService.getUserAttributesById(profileId);
            this.userAttributes = userAttribute ?? null;
        } catch(e) {
            this.userAttributes = null;
        }
        
    }

    private async getLenderAccountInfo() {
        const lenderId = this.storageService.getItem(Keys.LENDER_ID);
        try {
            const lenderAccountInfo: any = await this.accountService.getLenderAccountInfo(lenderId);
            this.lenderAccountInfo = lenderAccountInfo.data[0] ?? null;
            this.isShowInterestCertificateMenu();
        } catch(e) {
            this.lenderAccountInfo =  null;
        }
        
    }

    private async checkForPreferenceType() {
        try {
            await (this.userAttributes.count > 0) && this.userAttributes.data.forEach(preference => {
                if (preference?.investmentPreferences.find(preference => preference.attributeCode === AttributeCode.AUTO_INVESTMENT_FROM_WALLET_TYPE
                    && preference.attributeValue === AttributeValue.SWIFT)) {
                    this.isSwiftOn = true;
                    this.sharedPreferenceDataService.setSwiftValue(true);
                } else {
                    this.isSwiftOn = false;
                    this.sharedPreferenceDataService.setSwiftValue(false);
                }
                if (preference.investmentPreferences.find(preference => preference.attributeCode === AttributeCode.NCASH_WD_LIMIT)) {
                    this.isNCashOn = true;
                    this.sharedPreferenceDataService.setNCashValue(true);
                } else {
                    this.isNCashOn = false;
                    this.sharedPreferenceDataService.setNCashValue(false);
                }
            });
        } catch (error) {
            return Toaster.toast(`Something went wrong.`, Type.Error);
        }
    }

    private readPreferenceSharedData() {
        this.sharedPreferenceDataService.swiftStatus$?.subscribe((data) => {
            this.isSwiftOn = data;
        });
        this.sharedPreferenceDataService.nCashStatus$?.subscribe((data) => {
            this.isNCashOn = data;
        });
    }

    private async showEnableSwiftPopUp() {
        if (!this.storageService.getItem(Keys.FIRST_LOGIN)) {
            this.storageService.saveItem(Keys.FIRST_LOGIN, 'true');
            if (!this.isSwiftOn) {
                this.matDialog.open(EnableSwiftPreferencePopUpComponent,
                    {
                        width: '70%',
                        height: 'auto',
                        panelClass: 'enable-swift-pop-up'
                    }).afterClosed().subscribe(
                        async (result) => {
                            if (result) {
                                return await this.router.navigate([FfEndPoints.PREFERENCES]);
                            }
                        }
                    );
            }
        }
    }

    private showQuickSetupConfig() {
        this.router.events.subscribe(async (event: Event) => {
            if ((event instanceof NavigationEnd) && (event.url == `/${FfEndPoints.PREFERENCES}`)) {
                this.showQuickSetup = false;
            } else {
                this.showQuickSetup = true;
            }
        });
    }

    private isShowInterestCertificateMenu() {
        if (this.lenderAccountInfo) {
            document.getElementById('interestCertificate').style.display = "block";
        } else {
            document.getElementById('interestCertificate').style.display = "none"
        }
    }
}